import { render, staticRenderFns } from "./joget.vue?vue&type=template&id=e1dbadf2&scoped=true"
import script from "./joget.vue?vue&type=script&lang=js"
export * from "./joget.vue?vue&type=script&lang=js"
import style0 from "./joget.vue?vue&type=style&index=0&id=e1dbadf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dbadf2",
  null
  
)

export default component.exports